import Icons from '~/components/ui/Icons';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

const Select = ({ attrs = {}, className = '', children }) => {
  const { id, label } = attrs;

  return (
    <div className={cn('select-group', className)}>
      {label && (
        <label
          className="mb-1 text-small lg:text-small-lg text-grey"
          htmlFor={id}
        >
          {label}
        </label>
      )}

      <div className="relative w-full">
        <select className="select w-full appearance-none" {...attrs}>
          {children}
        </select>

        <Icons
          type="down"
          className="chevron center-vertical w-5 pointer-events-none"
        />
      </div>
    </div>
  );
};

Select.propTypes = {
  attrs: PropTypes.shape({
    id: function (props) {
      if (!props.label && props.id) {
        return new Error(
          `"label" is required when providing "id"—given "${props.label}`,
        );
      }
    },
    label: function (props) {
      if (!props.label && props.id) {
        return new Error(
          `"id" is required when providing "label"—given "${props.id}`,
        );
      }
    },
  }),
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default Select;
